import { Heading } from "@/components/ui/Heading";
import { Text } from "@/components/ui/Text";
import classes from "./ConfigLoadError.module.scss";
import { Container } from "@/components/ui/Container";

export function ConfigLoadError() {
  return (
    <div className={classes.pageCenter}>
      <Container maxWidth="sm">
        <div className={classes.iconWrapper}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            className={classes.icon}
          >
            <path
              stroke="currentColor"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M2 14.5A4.5 4.5 0 0 0 6.5 19h12a3.5 3.5 0 0 0 .5-6.965 7 7 0 0 0-13.76-1.857A4.5 4.5 0 0 0 2 14.5Z"
            ></path>
            <path
              stroke="currentColor"
              strokeLinejoin="round"
              strokeWidth="2.25"
              d="M12 15.5h.01v.01H12z"
            ></path>
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M12 12V9"
            ></path>
          </svg>
        </div>
        <Heading align="center" size="xl" as="h1">
          Sorry, something went wrong
        </Heading>
        <Text align="center">
          An unexpected error occurred. Please try again later.
        </Text>
      </Container>
    </div>
  );
}
